import React, { Component } from 'react'
import Card from './CardUI';

import img1 from "../../assets/national-cancer-institute-701-FJcjLAQ-unsplash.jpg";
import img2 from "../../assets/camilo-jimenez-vGu08RYjO-s-unsplash (1).jpg";
import img3 from "../../assets/Keep Working On It (1).jpg";

export default class Cards extends Component {
    render() {
        return(
            <div className="container-fluid d-flex justify-content-center">
                <div className="row">
                    <div className="col-md-4">
                        <Card imgsrc={img1} title="Select Domain of Rooms" description="Change and Set Rooms' Domain" href="/surgical/priority/domainofrooms"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img2} title="Change Priority" description="Change and Set Priorities" href="/surgical/priority/prioritypage"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img3} title="TBA" description="Under Maintanance" href="/nomatch"/>
                    </div>
                </div>
            </div>
            
        )
    }
}